import React from 'react'

const LabManagement = () => {
  return (
    <div className='mx-auto p-4'>
      LabManagement
    </div>
  )
}

export default LabManagement
